/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import Charges from './Charges/index'
import Expandable from './Expandable/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/TreatmentCard/PaymentsTreatmentPlan/Content/TreatmentPayments/Content/Content/SetupPayment/Breakdown/Treatment/Charges/Content"
  
}) {
  return (<React.Fragment
>
<Charges
  viewPath={`${viewPath}/Charges`}
/>
<Expandable
  viewPath={`${viewPath}/Expandable`}
/>
{children}
</React.Fragment>)
}